import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import ItinerariesApi from 'libs/api/website/itineraries';

const useSingleItinerary = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await ItinerariesApi.show(routeId);
        const item = response.data?.success
          ? response.data.itinerary
          : response.data?.itinerary;

        if (!cancelled) {
          setSingleItem(item || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleItinerary;
